import { CommonModule } from '@angular/common';
import { Component, Input} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BehaviorSubject } from 'rxjs';

export class ButtonOption {
  label: string;
  action: () => void;
  disabled?: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  hidden?: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
}

@Component({
  selector: 'buttons-prosegur',
  standalone: true,
  imports: [
    CommonModule,
    MatTooltipModule,
    MatButtonModule,
    TranslateModule
  ],
  templateUrl: './buttons-prosegur.component.html',
  styleUrls: ['./buttons-prosegur.component.sass']
})

export class ButtonsProsegurComponent 
{
  constructor() { }
  @Input() options: ButtonOption[] = [];
}